import { render, staticRenderFns } from "./Seasons.vue?vue&type=template&id=1253f870"
import script from "./Seasons.vue?vue&type=script&lang=js"
export * from "./Seasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports